import "./internal.js";
import LogoListener from "./lib/filter-handler.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import "@shoelace-style/shoelace/dist/components/icon/icon.js";
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js";
setBasePath("/wp-content/themes/posturepress3/shoelace-dist/dist/");
import { slDetails } from "@shoelace-style/shoelace/dist/components/details/details";
import FilterHandler from "./lib/filter-handler";
import storeLocatorFilterHandler from "./lib/store-locator-filter-handler.js";
import flagshipSVGTemplateTagCustomization from "./lib/flagship-svg-template-tag-customization.js";
import { initSlideshows } from "./lib/slideshows.js";

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();
	new FilterHandler();

	initSlideshows();

	// if on the store locator page, then run the store locator filter handler
	if (document.querySelector("#store-locator")) {
		storeLocatorFilterHandler();
	}
	flagshipSVGTemplateTagCustomization();

	headerSearchBarExpand();
});

const headerSearchBarExpand = () => {
	const searchForm = document.querySelector(".header-nav .search-form");
	if (!searchForm) {
		return;
	}
	const searchField = searchForm.querySelector(".search-field");
	const searchOverlay = searchForm.querySelector(".mobile-overlay");
	const searchCancel = searchForm.querySelector(".search-cancel");
	const searchSubmit = searchForm.querySelector(".search-submit");
	const searchResults = document.querySelector(".searchwp-live-search-results");
	if (!searchField || !searchOverlay || !searchCancel || !searchSubmit || !searchResults) {
		return;
	}

	// on search field value change
	searchField.addEventListener("input", () => {
		if (searchField.value.length > 0) {
			searchCancel.classList.add("active");
		} else {
			searchCancel.classList.remove("active");
		}
	});

	searchOverlay.addEventListener("click", (e) => {
		// e.preventDefault();
		if (searchForm.classList.contains("mobile-active")) {
			return;
		}
		searchForm.classList.toggle("mobile-active");
	});

	searchCancel.addEventListener("click", (e) => {
		e.preventDefault();
		// clear out the search field
		searchField.value = "";
		searchForm.classList.remove("mobile-active");
		searchCancel.classList.remove("active");
	});

	// add cancel event to any body click that doesn't include the search form
	document.body.addEventListener("click", (e) => {
		if (searchForm.classList.contains("mobile-active")) {
			if (!searchForm.contains(e.target) && !searchResults.contains(e.target)) {
				searchForm.classList.remove("mobile-active");
			}
		}
	});
};
